import { useEffect, useState, useMemo } from 'react'
import { Calendar } from 'lucide-react'
import { useAuth } from '@/contexts/AuthContext'
import { tumSubeleriGetir } from '@/lib/services/sube-service'
import { HaftalikPlanlama } from '@/pages/boss/vardiyalar/HaftalikPlanlama'
import type { Sube, KullaniciPersonel } from '@/types'

export function YoneticiVardiyalarPage() {
  const { kullanici } = useAuth()

  const benimSubeIdleri = useMemo<string[] | null>(() => {
    if (kullanici?.rol === 'boss') return null
    if (kullanici?.rol !== 'personel') return []
    return (kullanici as KullaniciPersonel).subeIdleri ?? []
  }, [kullanici])

  const [subeler, setSubeler] = useState<Sube[]>([])
  const [yukleniyor, setYukleniyor] = useState(true)
  const [hata, setHata] = useState<string | null>(null)

  useEffect(() => {
    let iptal = false
    setYukleniyor(true)
    tumSubeleriGetir()
      .then(s => {
        if (iptal) return
        const aktif = s.filter(x => x.aktif)
        const benim = benimSubeIdleri === null
          ? aktif
          : aktif.filter(x => benimSubeIdleri.includes(x.id))
        setSubeler(benim)
        setHata(null)
      })
      .catch(err => {
        console.error(err)
        if (!iptal) setHata('Şubeler yüklenemedi.')
      })
      .finally(() => {
        if (!iptal) setYukleniyor(false)
      })
    return () => { iptal = true }
  }, [benimSubeIdleri])

  if (yukleniyor) {
    return (
      <div className="card text-center py-12">
        <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-brand-600 mb-3"></div>
        <p className="text-gray-600">Yükleniyor...</p>
      </div>
    )
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <Calendar className="w-6 h-6 text-brand-600" />
        <h1 className="text-2xl font-bold text-gray-900">Vardiyalar</h1>
      </div>

      {hata && (
        <div className="bg-red-50 border border-red-200 text-red-800 rounded-xl p-3 text-sm">
          {hata}
        </div>
      )}

      {subeler.length === 0 ? (
        <div className="card text-center py-12">
          <Calendar className="w-12 h-12 text-gray-300 mx-auto mb-4" />
          <h3 className="font-bold text-gray-900 mb-2">Şube atanmamış</h3>
          <p className="text-gray-600 text-sm">
            BOSS'tan size bir şube atanması gerekiyor.
          </p>
        </div>
      ) : (
        <HaftalikPlanlama subeler={subeler} />
      )}
    </div>
  )
}
